import { formatDateRangeWithWeekdaysHe } from "./DatesHelpers";

/** Matches services/customer_chat_nlu.CVAC_SELECT_ROOM_PREFIX */
const CVAC_SELECT_ROOM_PREFIX = "__cvac_select_room__|";

/** Matches services/customer_chat_nlu.CVAC_LDS_PICK_PREFIX */
const CVAC_LDS_PREFIX = "__cvac_select_lds__|";

/** Matches services/customer_chat_nlu.CVAC_LOAD_MORE_HOTELS */
export const CVAC_LOAD_MORE_HOTELS = "__cvac_load_more_hotels__";

/** Matches services/customer_chat_nlu.CVAC_EXECUTE_PACKAGE_SEARCH */
export const CVAC_EXECUTE_PACKAGE_SEARCH = "__cvac_execute_search__";

/** Matches services/customer_chat_nlu.CVAC_REOPEN_PASSENGER_FORM */
export const CVAC_REOPEN_PASSENGER_FORM = "__cvac_reopen_passenger_form__";

/** Matches services/customer_chat_nlu.CVAC_SELECT_PAY_PREFIX */
const CVAC_SELECT_PAY_PREFIX = "__cvac_select_pay__|";

/** Matches services/customer_chat_nlu.CVAC_DD_STYLE_PREFIX */
const CVAC_DD_STYLE_PREFIX = "__cvac_dd_style__|";

/** Matches services/customer_chat_nlu.CVAC_DD_MORE_DEST */
const CVAC_DD_MORE_DEST = "__cvac_dd_more_dest__";

/** Matches services/customer_chat_nlu.CVAC_DD_BACK_STYLES */
const CVAC_DD_BACK_STYLES = "__cvac_dd_back_styles__";

/** Matches services/customer_chat_nlu.CVAC_NIGHT_PREFIX */
const CVAC_NIGHT_PREFIX = "__cvac_night__|";

/** Matches services/customer_chat_nlu.CVAC_NIGHTS_DONE */
const CVAC_NIGHTS_DONE = "__cvac_nights_done__";

/** Matches services/customer_chat_nlu.CVAC_NIGHTS_FLEX */
const CVAC_NIGHTS_FLEX = "__cvac_nights_flex__";

/** Matches services/customer_chat_nlu.CVAC_PICK_MONTH_PREFIX */
const CVAC_PICK_MONTH_PREFIX = "__cvac_pick_month__|";

/** Matches services/customer_chat_nlu.CVAC_PICK_DATE_RANGE_PREFIX */
const CVAC_PICK_DATE_RANGE_PREFIX = "__cvac_pick_daterange__|";

const CVAC_GUIDED_DEST_PREFIX = "__cvac_guided_dest__|";
const CVAC_GUIDED_PAX_PREFIX = "__cvac_guided_pax__|";
const CVAC_GUIDED_PAX_ADULTS_PREFIX = "__cvac_guided_pax_a__|";
const CVAC_GUIDED_PAX_CHILD_PREFIX = "__cvac_guided_pax_c__|";
const CVAC_GUIDED_DATES_PREFIX = "__cvac_guided_dates__|";
/** Matches services/customer_chat_nlu.CVAC_GUIDED_CYPRUS_PREFIX */
const CVAC_GUIDED_CYPRUS_PREFIX = "__cvac_guided_cyprus__|";

/** Matches services/customer_chat_nlu.CVAC_GUIDED_CSUB_PREFIX */
const CVAC_GUIDED_CSUB_PREFIX = "__cvac_guided_csub__|";

/** Matches services/customer_chat_nlu.CVAC_TOP_DEST_PREFIX — popular IATA quick-picks */
const CVAC_TOP_DEST_PREFIX = "__cvac_top_dest__|";

/** Post-results star filter (services/customer_chat_nlu) */
const CVAC_STARS_FILTER_ASK = "__cvac_stars_filter_ask__";
const CVAC_STARS_MIN_PREFIX = "__cvac_stars_min__|";

/** Hebrew labels for IATA quick-picks (align with services/customer_chat_destination_display). */
const CVAC_TOP_DEST_IATA_LABELS = {
  DXB: "דובאי",
  AYT: "אנטליה",
  LCA: "לרנקה",
  ATH: "אתונה",
  HER: "הרקליון",
  BKK: "בנגקוק",
  BCN: "ברצלונה",
  FCO: "רומא",
  SSH: "שרם א-שייח",
  RHO: "רודוס",
};

/** Mandatory pre-search (services/customer_chat_nlu) */
const CVAC_MAND_DEST_PREFIX = "__cvac_mand_dest__|";
const CVAC_MAND_DATES_PREFIX = "__cvac_mand_dates__|";
const CVAC_MAND_STARS_PREFIX = "__cvac_mand_stars__|";

const CVAC_MAND_DEST_LABELS = {
  specific: "יעד ספציפי",
  multi: "כמה יעדים",
  all: "כל היעדים",
};

const CVAC_MAND_DATES_LABELS = {
  exact: "תאריכים מדויקים",
  flexible: "גמיש",
};

const CVAC_MAND_STARS_LABELS = {
  any: "לא משנה",
  3: "3 כוכבים",
  4: "4 כוכבים",
  5: "5 כוכבים",
};

const CVAC_GUIDED_CSUB_IATA_LABELS = {
  ATH: "אתונה",
  RHO: "רודוס",
  HER: "כרתים",
  JTR: "סנטוריני",
  SKG: "סלוניקי",
  ZTH: "זקינטוס",
  CFU: "קורפו",
  FCO: "רומא",
  MXP: "מילאנו",
  VCE: "ונציה",
  NAP: "נאפולי",
  FLR: "פירנצה",
  BKK: "בנגקוק",
  HKT: "פוקט",
  ALL: "כל היעדים בארץ",
};

const CVAC_GUIDED_DEST_LABELS = {
  greece: "יוון",
  cyprus: "קפריסין",
  italy: "איטליה",
  thailand: "תאילנד",
  beach: "בטן גב",
  city: "עירוני",
  family: "משפחתי",
  more: "עוד יעדים",
};

const CVAC_GUIDED_PAX_LABELS = {
  couple: "זוג",
  "2a1c": "2 מבוגרים + ילד",
  "2a2c": "2 מבוגרים + 2 ילדים",
  family: "משפחה",
  group: "קבוצה",
  other: "אחר",
};

const CVAC_GUIDED_DATES_LABELS = {
  exact: "תאריכים מדויקים",
  flex: "גמיש",
  pick_month: "חודש ספציפי",
};

const CVAC_GUIDED_CYPRUS_LABELS = {
  lca: "לרנקה / איה נאפה",
  pfo: "פאפוס",
};

/** 1–12 → Hebrew month name (aligns with guided-flow month labels). */
const HEBREW_MONTH_NAMES = [
  "ינואר",
  "פברואר",
  "מרץ",
  "אפריל",
  "מאי",
  "יוני",
  "יולי",
  "אוגוסט",
  "ספטמבר",
  "אוקטובר",
  "נובמבר",
  "דצמבר",
];

const CVAC_DD_STYLE_LABELS_HE = {
  beach: "בטן־גב",
  family: "משפחתי",
  cheap: "יעד זול",
  nearby: "יעד קרוב",
  city: "עיר ונופש",
  open: "פתוח להצעות",
  luxury: "יוקרה",
};

/**
 * Short Hebrew label for a quick-reply chip from its machine `value` (mandatory pre-search).
 * @param {string} value
 * @returns {string | null}
 */
function mandatoryQuickValueToChipLabel(value) {
  const v = String(value || "").trim();
  if (v.startsWith(CVAC_MAND_DEST_PREFIX)) {
    const key = v.slice(CVAC_MAND_DEST_PREFIX.length).trim().toLowerCase();
    return CVAC_MAND_DEST_LABELS[key] || null;
  }
  if (v.startsWith(CVAC_MAND_DATES_PREFIX)) {
    const key = v.slice(CVAC_MAND_DATES_PREFIX.length).trim().toLowerCase();
    return CVAC_MAND_DATES_LABELS[key] || null;
  }
  if (v.startsWith(CVAC_MAND_STARS_PREFIX)) {
    const key = v.slice(CVAC_MAND_STARS_PREFIX.length).trim().toLowerCase();
    return CVAC_MAND_STARS_LABELS[key] || null;
  }
  return null;
}

/**
 * Recover Hebrew chip label when the server/UI sent a mangled protocol string as `label`.
 * @param {string} label
 * @returns {string | null}
 */
function recoverMandatoryChipLabelFromMangledText(label) {
  const s = String(label || "").trim();
  if (!s) return null;
  let m = /cvac_mand_dates__\s*\|\s*([a-z0-9_]+)/i.exec(s);
  if (m) {
    const key = m[1].replace(/_+$/i, "").toLowerCase();
    return CVAC_MAND_DATES_LABELS[key] || null;
  }
  m = /cvac_mand_dest__\s*\|\s*([a-z0-9_]+)/i.exec(s);
  if (m) {
    const key = m[1].replace(/_+$/i, "").toLowerCase();
    return CVAC_MAND_DEST_LABELS[key] || null;
  }
  m = /cvac_mand_stars__\s*\|\s*([a-z0-9_]+)/i.exec(s);
  if (m) {
    const key = m[1].replace(/_+$/i, "").toLowerCase();
    return CVAC_MAND_STARS_LABELS[key] || null;
  }
  return null;
}

/**
 * Visible text for assistant quick-reply buttons (never raw `__cvac_*` tokens).
 * @param {{ label?: string, value?: string } | null | undefined} qr
 * @returns {string}
 */
export function displayQuickReplyButtonLabel(qr) {
  const value = qr?.value != null ? String(qr.value).trim() : "";
  const label = qr?.label != null ? String(qr.label).trim() : "";
  if (value === CVAC_REOPEN_PASSENGER_FORM) return label || "עריכת פרטים";
  const fromValue = value ? mandatoryQuickValueToChipLabel(value) : null;
  if (fromValue) return fromValue;
  const recovered = recoverMandatoryChipLabelFromMangledText(label);
  if (recovered) return recovered;
  if (label && !/__?cvac_/i.test(label)) return label;
  return label || value;
}

/**
 * אייקון MUI ליד תווית כפתור quick-reply (ללא אימוג'י בטקסט).
 * @param {{ label?: string, value?: string } | null | undefined} qr
 * @returns {"edit"|"payment"|null}
 */
export function quickReplyIconHint(qr) {
  const v = qr?.value != null ? String(qr.value).trim() : "";
  const lab = qr?.label != null ? String(qr.label).trim() : "";
  const t = `${v} ${lab}`;
  if (v === CVAC_REOPEN_PASSENGER_FORM) return "edit";
  if (/תשלום|קישור תשלום|payment|pay/i.test(t)) return "payment";
  return null;
}

function formatMandatoryPresearchUserBubble(t) {
  const v = String(t || "").trim();
  if (v.startsWith(CVAC_MAND_DEST_PREFIX)) {
    const key = v.slice(CVAC_MAND_DEST_PREFIX.length).trim().toLowerCase();
    const lab = CVAC_MAND_DEST_LABELS[key];
    return lab ? `בחירת היקף יעד: ${lab}` : null;
  }
  if (v.startsWith(CVAC_MAND_DATES_PREFIX)) {
    const key = v.slice(CVAC_MAND_DATES_PREFIX.length).trim().toLowerCase();
    const lab = CVAC_MAND_DATES_LABELS[key];
    return lab ? `בחירת סוג תאריכים: ${lab}` : null;
  }
  if (v.startsWith(CVAC_MAND_STARS_PREFIX)) {
    const key = v.slice(CVAC_MAND_STARS_PREFIX.length).trim().toLowerCase();
    const lab = CVAC_MAND_STARS_LABELS[key];
    return lab ? `בחירת דירוג מלון: ${lab}` : null;
  }
  const recovered = recoverMandatoryChipLabelFromMangledText(v);
  if (recovered) {
    if (/cvac_mand_dates__/i.test(v)) return `בחירת סוג תאריכים: ${recovered}`;
    if (/cvac_mand_dest__/i.test(v)) return `בחירת היקף יעד: ${recovered}`;
    if (/cvac_mand_stars__/i.test(v)) return `בחירת דירוג מלון: ${recovered}`;
  }
  return null;
}

/**
 * User-visible text for chat bubbles (hides machine protocol strings).
 */
export function displayUserChatMessage(text) {
  const t = String(text || "").trim();
  const mandBubble = formatMandatoryPresearchUserBubble(t);
  if (mandBubble) return mandBubble;
  if (t.startsWith(CVAC_SELECT_ROOM_PREFIX)) {
    const rest = t.slice(CVAC_SELECT_ROOM_PREFIX.length).trim();
    const parts = rest.split("|").map((p) => p.trim()).filter(Boolean);
    if (parts.length >= 2) {
      return `בחירת חדר מהרשימה (אפשרות ${parts[0]}, חדר #${Number(parts[1]) + 1})`;
    }
    return "בחירת חדר מהרשימה";
  }
  if (t.startsWith(CVAC_LDS_PREFIX)) {
    return "בחרתי אופציית חבילה אחרת לאותו מלון";
  }
  if (t === CVAC_LOAD_MORE_HOTELS) {
    return "מבקשים עוד מלונות מהחיפוש";
  }
  if (t === CVAC_EXECUTE_PACKAGE_SEARCH) {
    return "מריצים חיפוש חבילות";
  }
  if (t.startsWith(CVAC_SELECT_PAY_PREFIX)) {
    return "ביקשתי קישור תשלום לחבילה";
  }
  if (t.startsWith(CVAC_DD_STYLE_PREFIX)) {
    const key = t.slice(CVAC_DD_STYLE_PREFIX.length).trim().toLowerCase();
    return CVAC_DD_STYLE_LABELS_HE[key] || "בחרתי כיוון לחופשה";
  }
  if (t === CVAC_DD_MORE_DEST) {
    return "מבקשים עוד יעדים";
  }
  if (t === CVAC_DD_BACK_STYLES) {
    return "רוצים כיוון אחר לחופשה";
  }
  if (t.startsWith(CVAC_NIGHT_PREFIX)) {
    const n = t.slice(CVAC_NIGHT_PREFIX.length).trim();
    return n ? `בחירת ${n} לילות` : "בחירת משך לילות";
  }
  if (t === CVAC_NIGHTS_DONE) {
    return "סיימתי לבחור משך לילות";
  }
  if (t === CVAC_NIGHTS_FLEX) {
    return "גמישות במספר לילות";
  }
  if (t.startsWith(CVAC_PICK_MONTH_PREFIX)) {
    const rest = t.slice(CVAC_PICK_MONTH_PREFIX.length).trim();
    const m = /^(\d{4})-(\d{2})$/.exec(rest);
    if (m) {
      const year = m[1];
      const mo = parseInt(m[2], 10);
      if (mo >= 1 && mo <= 12) {
        const name = HEBREW_MONTH_NAMES[mo - 1];
        return `מחפשים חבילות לחודש ${name} ${year}`;
      }
    }
    return "מחפשים חבילות לחודש שבחרתי";
  }
  if (t.startsWith(CVAC_PICK_DATE_RANGE_PREFIX)) {
    const rest = t.slice(CVAC_PICK_DATE_RANGE_PREFIX.length).trim();
    const parts = rest.split("|");
    if (parts.length === 2) {
      const range = formatDateRangeWithWeekdaysHe(parts[0], parts[1]);
      return range ? `בחירת תאריכים: ${range}` : "בחירת טווח תאריכים";
    }
    return "בחירת טווח תאריכים";
  }
  if (t.startsWith(CVAC_GUIDED_DEST_PREFIX)) {
    const key = t.slice(CVAC_GUIDED_DEST_PREFIX.length).trim().toLowerCase();
    return CVAC_GUIDED_DEST_LABELS[key]
      ? `בחירת יעד: ${CVAC_GUIDED_DEST_LABELS[key]}`
      : "בחירת יעד מההדרכה";
  }
  if (t.startsWith(CVAC_GUIDED_PAX_ADULTS_PREFIX)) {
    const key = t.slice(CVAC_GUIDED_PAX_ADULTS_PREFIX.length).trim().toLowerCase();
    const label = key === "5p" ? "5+ מבוגרים" : key ? `${key} מבוגרים` : "";
    return label ? `מספר מבוגרים: ${label}` : "בחירת מספר מבוגרים";
  }
  if (t.startsWith(CVAC_GUIDED_PAX_CHILD_PREFIX)) {
    const key = t.slice(CVAC_GUIDED_PAX_CHILD_PREFIX.length).trim().toLowerCase();
    const label = key === "4p" ? "4+ ילדים" : key !== "" ? `${key} ילדים` : "";
    return label ? `מספר ילדים: ${label}` : "בחירת מספר ילדים";
  }
  if (t.startsWith(CVAC_GUIDED_PAX_PREFIX)) {
    const key = t.slice(CVAC_GUIDED_PAX_PREFIX.length).trim().toLowerCase();
    return CVAC_GUIDED_PAX_LABELS[key]
      ? `בחירת נוסעים: ${CVAC_GUIDED_PAX_LABELS[key]}`
      : "בחירת נוסעים";
  }
  if (t.startsWith(CVAC_GUIDED_DATES_PREFIX)) {
    const key = t.slice(CVAC_GUIDED_DATES_PREFIX.length).trim().toLowerCase();
    return CVAC_GUIDED_DATES_LABELS[key]
      ? `בחירת תאריכים: ${CVAC_GUIDED_DATES_LABELS[key]}`
      : "בחירת תאריכים";
  }
  if (t.startsWith(CVAC_GUIDED_CYPRUS_PREFIX)) {
    const key = t.slice(CVAC_GUIDED_CYPRUS_PREFIX.length).trim().toLowerCase();
    return CVAC_GUIDED_CYPRUS_LABELS[key]
      ? `בחירת אזור בקפריסין: ${CVAC_GUIDED_CYPRUS_LABELS[key]}`
      : "בחירת אזור בקפריסין";
  }
  if (t.startsWith(CVAC_GUIDED_CSUB_PREFIX)) {
    const rest = t.slice(CVAC_GUIDED_CSUB_PREFIX.length).trim();
    const parts = rest.split("|").map((p) => p.trim()).filter(Boolean);
    if (parts.length >= 2) {
      const code = parts[1].toUpperCase();
      const label = CVAC_GUIDED_CSUB_IATA_LABELS[code];
      return label ? `בחירת יעד: ${label}` : `בחירת יעד (${code})`;
    }
    return "בחירת יעד במדינה";
  }
  if (t.startsWith(CVAC_TOP_DEST_PREFIX)) {
    const code = t.slice(CVAC_TOP_DEST_PREFIX.length).trim().toUpperCase();
    const label = CVAC_TOP_DEST_IATA_LABELS[code];
    return label ? `בחירת יעד: ${label}` : code ? `בחירת יעד (${code})` : "בחירת יעד";
  }
  if (t === CVAC_STARS_FILTER_ASK) {
    return "סינון לפי דירוג כוכבים";
  }
  if (t.startsWith(CVAC_STARS_MIN_PREFIX)) {
    const rest = t.slice(CVAC_STARS_MIN_PREFIX.length).trim().toLowerCase();
    if (rest === "clear") return "ביטול סינון כוכבים / הצגת הכל";
    if (rest === "5") return "סינון: 5 כוכבים";
    if (rest && /^[2-4]$/.test(rest)) return `סינון: ${rest} כוכבים ומעלה`;
    return "בחירת דירוג כוכבים לסינון";
  }
  return t;
}
